







































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import AMSDialog from '@/components/AMSDialog.vue';
import { emptyRule } from '@/utils/rules';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
interface CategoryModel {
  id?: string;
  name: string;
  items?: CategoryModel[];
  active: boolean;
  isStatic?: boolean;
}
interface DialogCategoryModel {
  parentItem?: CategoryModel;
  currentItem?: CategoryModel;
  isEdit?: boolean;
}

@Component({
  components: {
    'ams-dialog': AMSDialog,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class ProductCategory extends Vue {
  breadcrumbsItems = [
    {
      text: '系统设置',
      disabled: false,
      href: '/systemSetting/productCategory'
    },
    {
      text: '商品分类',
      disabled: true
    }
  ];
  category: string = '';
  form: boolean = true;
  valid: boolean = true;
  categorys: CategoryModel[] = [];
  nameRules: Array<any> = [emptyRule('分类名称')];
  dialog: boolean = false;
  deleteDialog: boolean = false;
  dialogCategory: DialogCategoryModel = {};
  deleteItem: DialogCategoryModel = {};
  currentCategory: string = '';
  requestLoading: boolean = false;
  get showParentCategory() {
    if (this.dialogCategory.isEdit) {
      return this.dialogCategory.parentItem && this.dialogCategory.parentItem.name;
    } else {
      return this.dialogCategory.currentItem && this.dialogCategory.currentItem.name;
    }
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }

  /**保持打开状态 */
  getActive(item: any) {
    for (let i = 0; i < this.categorys.length; i++) {
      const level1 = this.categorys[i];
      if (level1.id == item.id) {
        return level1.active;
      }
      if (level1.items && level1.items.length > 0) {
        for (let j = 0; j < level1.items.length; j++) {
          const level2 = level1.items[j];
          if (level2.id == item.id) {
            return level2.active;
          }
        }
      }
    }
    return false;
  }

  getProductCategory() {
    request.get('/api/Product/category/list').then((data: any) => {
      const items = data.map((d: any, j: number) => {
        d.active = this.getActive(d);
        if (d.items && d.items.length > 0) {
          d.items.map((i: any, k: number) => {
            i.active = this.getActive(i);
            return i;
          });
        }
        return d;
      });
      this.categorys = items;
    });
  }

  createNewCategory() {
    this.$refs.form && (this.$refs.form as any).resetValidation();
    this.dialog = true;
    this.dialogCategory.isEdit = false;
    this.currentCategory = '';
  }
  createCategory(item: DialogCategoryModel) {
    this.$refs.form && (this.$refs.form as any).resetValidation();
    this.dialog = true;
    this.dialogCategory = item;
    this.dialogCategory.isEdit = false;
    this.currentCategory = '';
  }
  editCategory(item: DialogCategoryModel) {
    this.$refs.form && (this.$refs.form as any).resetValidation();
    this.dialog = true;
    this.dialogCategory = item;
    this.dialogCategory.isEdit = true;
    this.currentCategory = item.currentItem!.name;
  }
  deleteCategory(item: DialogCategoryModel) {
    this.deleteDialog = true;
    this.deleteItem = item;
  }

  deleteSure() {
    this.requestLoading = true;
    request
      .del(`/api/Product/category/${this.deleteItem.currentItem!.id}`, null)
      .then((data: any) => {
        this.getProductCategory();
        this.deleteDialog = false;
        this.deleteItem = {};
      })
      .finally(() => {
        this.requestLoading = false;
      })
      .catch((err: any) => {
        this.requestLoading = false;
      })
  }
  deleteCancel() {
    this.deleteDialog = false;
    this.deleteItem = {};
  }
  cancel() {
    this.dialog = false;
    this.dialogCategory = {};
  }
  save(stop: Function) {
    if ((this.$refs.form as any).validate()) {
      let requestApi = null;
      if (this.dialogCategory.isEdit) {
        requestApi = request.put(`/api/Product/category`, { name: this.currentCategory, id: this.dialogCategory.currentItem!.id });
      } else {
        requestApi = request.post('/api/Product/category', { name: this.currentCategory, parentId: this.dialogCategory.currentItem ? this.dialogCategory.currentItem!.id : null });
      }
      this.requestLoading = true;
      requestApi
        .then((data: any) => {
          this.getProductCategory();
          this.dialog = false;
          this.currentCategory = '';
          this.dialogCategory = {};
        })
        .finally(() => {
          this.requestLoading = false;
          stop()
        })
        .catch((err: any) => {
          stop()
          this.requestLoading = false;
          stop();
        });
    } else {
      stop()
    }
  }
  created() {
    this.getProductCategory();
  }
}
